import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from './notification-badge.styles';
const getNumeric = (n) => typeof n === 'number' ? n : isNaN(parseInt(n)) ? 0 : parseInt(n);
const ceilMax = (max) => (n) => {
    const numericValue = getNumeric(n);
    const numericMax = getNumeric(max);
    return numericValue >= numericMax ? `${numericMax}+` : n;
};
export const NotificationBadge = ({ children, className, indeterminate, maxNumber = 99, ...props }) => {
    let variant = 'circle';
    const value = String(ceilMax(maxNumber)(getNumeric(children !== null && children !== void 0 ? children : 0)));
    const stretches = typeof children === 'string'
        ? String(children).length >= 2 // If it’s a String (case of "99+")
        : children !== undefined && children >= 10;
    const cropped = parseFloat(value) === maxNumber;
    const valueIsNotNull = children !== undefined && children !== null && parseInt(value) > 0;
    if (stretches) {
        variant = 'pill';
    }
    if (cropped) {
        variant = 'widePill';
    }
    return valueIsNotNull ? (_jsx(Styled.NotificationBadge, { "$variant": variant, className: className, "data-xds": "NotificationBadge", size: "small", ...props, children: value })) : !valueIsNotNull && indeterminate ? (_jsx(Styled.NotificationBadge, { "$variant": "circle", className: className, "data-xds": "NotificationBadge", size: "small", ...props })) : null;
};
NotificationBadge.displayName = 'NotificationBadge';
//# sourceMappingURL=notification-badge.js.map